import { defineStore } from "pinia";
import { api } from "@/app/services/api.service";

export interface PractitionersRegistryState {
  practitioner_registry: any
  practitioner_details: any
  practitioner_task: any
  practitioner_messages: any
  practitioner_message_error: any
  practitioner_complaint: any;
  practitioner_complaint_error: any;
  practitioner_complaints: any;
  practitioner_complaints_error: any;
  error: any
}

export interface PractitionerFilters {
  page: number
  limit: number
  search: string
}

export const usePractitionersRegistryStore = defineStore('practitionersRegistry', {
  state: (): PractitionersRegistryState => ({
    practitioner_registry: null,
    practitioner_details: null,
    practitioner_task: null,
    practitioner_messages: null,
    practitioner_message_error: null,
    practitioner_complaint: null,
    practitioner_complaint_error: null,
    practitioner_complaints: null,
    practitioner_complaints_error: null,
    error: null,
  }),

  getters: {
    getPractitionerRegistry: (state) => state.practitioner_registry,
    getPractitionerDetails: (state) => state.practitioner_details,
    getPractitionerRegistryError: (state) => state.error,
    getPractitionerTask: (state) => state.practitioner_task,
    getPractitionerMessages: (state) => state.practitioner_messages,
    getPractitionerMessageError: (state) => state.practitioner_message_error,
    getPractitionerComplaint: (state) => state.practitioner_complaint,
    getPractitionerComplaintError: (state) => state.practitioner_complaint_error,
    getPractitionerComplaints: (state) => state.practitioner_complaints,
    getPractitionerComplaintsError: (state) => state.practitioner_complaints_error
  },

  actions: {
    async fetchPractitionerRegistry(data: PractitionerFilters) {
      try {
        const response = await api().get('/insolvency/api/practitioners?page=' + data.page + '&perPage=' + data.limit + '&search=' + data.search)
        this.practitioner_registry = response.data
        this.error = null
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchPractitionerDetails(id: string | number) {
      try {
        const response = await api().get('/insolvency/api/practitioners/unique-practitioner-number/' + id)
        this.practitioner_details = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchPractitionerTaskMessages(id: string | number) {
      try {
        const response = await api().get('/insolvency/api/practitioners/task-messages/' + id)
        this.practitioner_task = response.data?.task
        this.practitioner_messages = response.data?.messages
      } catch (error: any) {
        this.practitioner_message_error = error.response?.data
      }
    },

    async logPractitionerComplaint(data: any) {
      try {
        const response = await api().post("/insolvency/api/practitioners/complaints", data);
        this.practitioner_complaint = response.data;
        this.practitioner_complaint_error = null;
      } catch (error: any) {
        this.practitioner_complaint_error = error.response?.data;
      }
    },

    async fetchPractitionerComplaints(query: any) {
      try {
        let path = "/insolvency/api/practitioners/complaints?page=" + query.page + "&perPage=" + query.perPage;
        if (query.status) path += "&status=" + query.status;
        if (query.practitionerNumber) path += "&practitionerNumber=" + query.practitionerNumber;
        const response = await api().get(path);
        this.practitioner_complaints = response.data;
        this.practitioner_complaints_error = null;
      } catch (error: any) {
        this.practitioner_complaints_error = error.response?.data;
      }
    }
  },
})
